import axios from 'axios';
const family = {
    
	actions: {
		processfamily(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Family/ProcessFamily', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {	                   									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},	
		getfamily({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get('/Family/GetFamily?Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getfamilybyid({rootState},Id){
			return new Promise((resolve, reject) => {				
				axios.get('/Family/GetFamilybyId?Id='+Id+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getfamilybysearch({rootState},searchVal){
			return new Promise((resolve, reject) => {				
				axios.get('/Family/GetFamilybySearch?SearchItem='+searchVal+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		}    
	}
}

export default family